import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Button,
  Row,
  Col,
  Collapse,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Card,
  CardText
} from "reactstrap";
import classNames from "classnames";
import styled from "styled-components";
import SwitchToggle from "../Forms/SwitchToggle";
import InputRadio from "../Forms/Input/Radio";
import { TextRupiah } from "../Text";
import {
  BANKTRANSFER,
  CREDITCARD,
  FULLWALLET,
  AKULAKU,
  BCA_VA,
  BNI_VA,
  PERMATA_VA,
  MANDIRI_VA,
  VIRTUALACCOUNT,
  BCA_INSTALLMENTS,
  KREDIVO,
  GOPAY,
  DEFAULT_CREDIT_CARD,
  DEFAULT_PAYMENT_METHOD
} from '../../constants/paymentMethods';
import { convertToRupiah } from "../../utils";
import plusButton from '../../images/plus-button.png';
import umbreCheck from '../../images/correct.png';
import CloseButton from '../../images/close-button-white.png';
import { defaultCreditCard } from '../../components/PageCheckout/BottomSection';

class PaymentOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _paymentType: props._paymentType,
      _paymentMethods: DEFAULT_PAYMENT_METHOD
    }
  }

  componentDidMount() {
    const setPayment = [];
    const { variant_payment_methods } = this.props.dataProductDetails;
    if (variant_payment_methods && variant_payment_methods.length > 0) {
      const dataPayments = this.state._paymentMethods.map(payments => {
        var variantPaymentMethod = Object.assign({}, payments);
        variant_payment_methods.find(item => {
          const isSetPayment = setPayment.includes(item.payment_method) ? setPayment : setPayment.push(item.payment_method);
          if (!setPayment.includes(payments.payment_method))
            variantPaymentMethod.active = false;
          else
            variantPaymentMethod.active = true;
        })
        return variantPaymentMethod;
      });
      const paymentType = setPayment.length && setPayment.includes(BCA_VA) ? BCA_VA :
        setPayment.length && setPayment.includes(BANKTRANSFER) ? BANKTRANSFER :
          setPayment.length && (setPayment.includes(KREDIVO) || setPayment.includes(AKULAKU)) ? DEFAULT_CREDIT_CARD :
            (setPayment.length ? setPayment[0] : null);
      this.setState({
        _paymentMethods: dataPayments,
        _paymentType: paymentType
      }, () => {
        if (paymentType) {
          if (paymentType === FULLWALLET)
            this.props._handleWalletPaymentCheckedChange(!this.props.walletPayment, paymentType)
          else
            this.props._setPaymentType(paymentType);
        }
      })
    }
  }

  _isDisabled = (balance, total) => {
    return parseInt(balance) < parseInt(total);
  };

  render() {
    const isIndonesian =
      this.props.dataAuth &&
      this.props.dataAuth.userdata &&
      this.props.dataAuth.userdata.country_code === "IDN";

    const totalAllUsageBalance = this.props.sellerCreditUsage + this.props.balanceUsage + this.props.kickPointsUsage;
    const remainingPayment = this.props._getTotal() - totalAllUsageBalance;
    const totalActiveBalance = this.props.sellerCredit + this.props._balanceUser;
    const totalAllBalance = this.props.sellerCredit + this.props._balanceUser + this.props.kickPoints;
    const remainingUseKickPoint = (this.props._getTotal() - (this.props.sellerCreditUsage + this.props.balanceUsage));

    return (
      <Form
        style={{ display: "flex", flexDirection: "column", padding: "0" }}
        className="form-shipping payment"
      >
        {/* <div
        className={classNames("payment-method-wrapper", {
          balance: this._isDisabled(
            this.props._balance, this.props._getTotal()
          ) || !this.state._paymentMethods.filter(item => item.active && item.payment_group === 3).length
        })}
        onClick={() =>
          this.props._handleWalletPaymentCheckedChange(!this.props.walletPayment, this.state._paymentType)
        }
      >
        <Row>
          <SwitchToggle active={this.props.walletPayment} title="Kick Credit" />
        </Row>
        <Row className="kick-credit-box">
          <Col className="kick-credit-check">
            <p>
              Balance:{" "}
              <TextRupiah
                prefix="IDR. "
                color="black"
                align="right"
                value={this.props._balance && this.props._balance.toString()}
              />
            </p>
          </Col>
        </Row>
      </div> */}
        <Row className="credit-method">
          <Col>
            <span className="title-credit">Use Credit</span>
          </Col>
        </Row>
        <div
          className={classNames("payment-method-wrapper", {
            balance: !this.state._paymentMethods.filter(
              (item) => item.active && item.payment_group === 3
            ).length || this.state.creditDebitOnly
          })}
        >
          <IconWrapper onClick={this.props.onToggleBalanceInfo}>
            <i className="fa fa-info-circle" />
          </IconWrapper>
          <div className="use-credit-container">
            <SwitchToggle
              active={this.props.isCreditUse}
              onClick={() => this.props._handleWalletPaymentCheckedChange(!this.props.walletPayment, this.state._paymentType)}
              disabled={this.props._getTotal() > totalAllBalance || totalAllBalance == 0 || this.state.creditDebitOnly}
            />
            <div className="balance-info-wrapper">
              <span>Credit</span>
              <span>Balance: {totalActiveBalance > 0 ? convertToRupiah(totalActiveBalance) : 0}</span>
              <div className="balance-amount-wrapper">
                <span className="balance-amount">{`Kick Credit: ${convertToRupiah(this.props._balanceUser)}`}</span>
                <span className="balance-amount">{`Seller Credit: ${convertToRupiah(this.props.sellerCredit)}`}</span>
              </div>
            </div>
          </div>
          <div className="use-credit-container">
            <SwitchToggle
              active={this.props.isUseKickPoints}
              disabled={this.props._getTotal() > totalAllBalance || remainingUseKickPoint == 0 || this.props.kickPoints == 0 || this.state.creditDebitOnly}
              onClick={() => this.props._handleKickPointCheckedChange(!this.props.isUseKickPoints, this.state._paymentType)} />
            <div className="balance-info-wrapper">
              <span>Use Kick Points</span>
              <span>Balance: {convertToRupiah(this.props.kickPoints)}</span>
            </div>
          </div>
        </div>
        <Collapse
          className="collapse-container-kickwallet"
          isOpen={!this.props.isCreditUse && !this.props.isUseKickPoints}
        >
          <Row className="credit-method">
            <Col>
              <span className="title-credit">Payment Method</span>
            </Col>
          </Row>
          <div className="payment-method-wrapper">
            {
              this.state._paymentMethods.map(item => {
                if (item.payment_group === 1 &&
                  item.payment_method !== AKULAKU) {
                  return (
                    <div key={item.payment_method}>
                      <InputRadio
                        label={item.label}
                        creditCard={item.payment_method === DEFAULT_CREDIT_CARD}
                        bordered={[BANKTRANSFER].includes(item.payment_method) || item.label === "Credit Card / Debit Card / Installments"}
                        title={![BANKTRANSFER, DEFAULT_CREDIT_CARD, BCA_INSTALLMENTS, CREDITCARD].includes(item.payment_method) ? 'Virtual Account' : null}
                        name="_paymentType"
                        active={(item.active && isIndonesian) ||
                          (isIndonesian && item.payment_method === DEFAULT_CREDIT_CARD) ||
                          (!isIndonesian && item.payment_method === DEFAULT_CREDIT_CARD)}
                        value={item.payment_method}
                        checked={this.props._paymentType === item.payment_method}
                        onChange={this.props._handlePaymentTypeChange}
                        subTitle={item.payment_method === BANKTRANSFER ? 'Payment verification manually. (Only office hours).' : 'Payment verification automatically.'}
                      >
                        {item.label}
                      </InputRadio>
                    </div>
                  )
                }
                return null;
              })
            }
          </div>
        </Collapse>
        <div className="checkout-summary">
          <Row className="row-item">
            <Col xs={6} className="col-item">
              <p>Product Price</p>
            </Col>
            <Col xs={6} className="col-item">
              <p>
                <TextRupiah
                  prefix="IDR. "
                  color="black"
                  align="right"
                  value={this.props.offerAmount.toString()}
                />
              </p>
            </Col>
          </Row>
          <Row className="row-item">
            <Col xs={6} className="col-item">
              <p>Shipping and Handling</p>
            </Col>
            <Col xs={6} className="col-item">
              <p>
                <TextRupiah
                  prefix="IDR. "
                  color="black"
                  align="right"
                  value={this.props._shippingFee.toString()}
                />
              </p>
            </Col>
          </Row>
          {
            this.props._admFee() > 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Admin Fee</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    prefix="IDR. "
                    color="black"
                    align="right"
                    value={this.props._admFee().toString()}
                  />
                </p>
              </Col>
            </Row>
          }
          {
            this.props._productPromo > 0 &&
            <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Additional Product</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    prefix="IDR. "
                    color="black"
                    align="right"
                    value={this.props._productPromo}
                  />
                </p>
              </Col>
            </Row>
          }
          {
            this.props.balanceUsage !== 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Kick Credit Usage</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    // minus={this.props.isCreditUse && (this.props.balanceUsage > 0)}
                    minus={this.props.isCreditUse && (this.props.balanceUsage > 0) ? "- " : ""}
                    value={this.props.isCreditUse && this.props.balanceUsage ? this.props.balanceUsage.toString() : ""}
                    color="red"
                  />
                </p>
              </Col>
            </Row>
          }
          {
            this.props.sellerCreditUsage !== 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Seller Credit Usage</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    // minus={this.props.isCreditUse && (this.props.sellerCreditUsage > 0)}
                    minus={this.props.isCreditUse && (this.props.sellerCreditUsage > 0) ? "- " : ""}
                    value={this.props.isCreditUse && this.props.sellerCreditUsage ? this.props.sellerCreditUsage.toString() : ""}
                    color="red"
                  />
                </p>
              </Col>
            </Row>
          }
          {
            this.props.kickPointsUsage !== 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Kick Point Usage</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    // minus={this.props.isUseKickPoints && (this.props.kickPointsUsage > 0)}
                    minus={this.props.isUseKickPoints && (this.props.kickPointsUsage > 0) ? "- " : ""}
                    value={this.props.isUseKickPoints && this.props.kickPointsUsage > 0 ? this.props.kickPointsUsage.toString() : ""}
                    color="red"
                  />
                </p>
              </Col>
            </Row>
          }
          <Row className="row-item">
            <Col xs={6} className="col-item">
              <p>
                <span>TOTAL</span>
              </p>
            </Col>
            <Col xs={6} className="col-item">
              <p>
                <TextRupiah
                  prefix="IDR. "
                  value={remainingPayment > 0 ? remainingPayment.toString() : 0}
                />
              </p>
            </Col>
          </Row>
        </div>
      </Form>
    );
  }
}

const IconWrapper = styled.div`
  position: absolute;
  right: 0px;
  font-size: 18px;
  color: #159953;
  cursor: pointer;
  width: 30px;
  height: 30px;
`

const mapStateToProps = state => ({
  dataProductDetails: state.dataProduct.productDetails
});
export default connect(mapStateToProps)(PaymentOffer);